import styled from 'styled-components'

import { tokens } from 'styling/tokens'

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const StatsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.raised};
`

export const StatChips = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const StatChip = styled.span`
  font-size: 12px;
  color: ${tokens.text.secondary};
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  background: ${tokens.surface.inset};
  b {
    color: ${tokens.text.primary};
    font-weight: 600;
    margin-left: 0.25rem;
  }
`

export const Workspace = styled.div`
  display: grid;
  grid-template-columns: 1fr 22rem;
  gap: 1rem;
  align-items: stretch;
  min-height: 28rem;
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const MapArea = styled.div`
  min-height: 28rem;
  height: calc(100vh - 18rem);
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid ${tokens.border.hairline};
  @media (max-width: 1100px) {
    height: 32rem;
  }
`

export const MapToolsPanel = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: calc(100vh - 18rem);
  overflow-y: auto;
  min-width: 0;
  @media (max-width: 1100px) {
    max-height: none;
  }
`

export const OpsPanel = styled.div`
  border-radius: 0.75rem;
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.raised};
  overflow: hidden;
`

export const OpsTabBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid ${tokens.border.hairline};
  overflow-x: auto;
`

export const OpsTab = styled.button<{ $active?: boolean }>`
  border: none;
  background: ${(p) => (p.$active ? tokens.accent.base + '26' : 'transparent')};
  color: ${(p) => (p.$active ? tokens.accent.base : tokens.text.secondary)};
  font-size: 13px;
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    color: ${tokens.text.primary};
    background: ${tokens.surface.inset};
  }
`

export const OpsTabContent = styled.div`
  padding: 1rem;
  max-height: 18rem;
  overflow-y: auto;
`

export const KV = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: ${tokens.text.primary};
  b {
    font-weight: 600;
  }
`

export const Hint = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${tokens.text.secondary};
`

export const EventRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  font-size: 14px;
  color: ${tokens.text.primary};
  border-bottom: 1px solid ${tokens.border.hairline};
  &:last-child {
    border-bottom: none;
  }
`

export const MappingRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  &:last-child {
    border-bottom: none;
  }
`

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 12px;
  color: ${tokens.text.secondary};
`

export const LegendDot = styled.span<{ $color: string }>`
  width: 0.75rem;
  height: 0.25rem;
  border-radius: 999px;
  background: ${(props) => props.$color};
`
